import type { ComponentProps } from 'react';
import { TransferBatchStatus } from '@frameio/shared/transfers/states';
import type { LinearProgress } from '@frameio/vapor';
import type { TransferBatch } from '../../../types/uploader';

export const getTrackColor = (
  job: TransferBatch
): ComponentProps<typeof LinearProgress>['variant'] => {
  const { isPaused, fileCounts, progress, status } = job;
  if (!fileCounts || !progress) {
    return 'neutral';
  }
  const failed = fileCounts.failed;
  const progressType = progress.progressType;
  if (
    failed &&
    (status === TransferBatchStatus.FAILED ||
      status === TransferBatchStatus.SUCCEEDED)
  )
    return 'error';

  if (isPaused) return 'neutral';
  if (progressType === 'DOWNLOAD') return 'success';
  if (progressType === 'RENDER') return 'pink';
  return 'brand';
};
